module.exports = __webpack_public_path__ + "static/media/skull.25ee2428.svg";